<template>
  <div class="exam">
    <div class="nuv">
      <a href="#" class="active">语音考核</a>
    </div>
    <div class="tips" v-if="tjkExamRecord == null">
      <p>目前考核不存在或考核已经结束。</p>
    </div>
    <div class="tips" v-if="isCurrent == 'Yes'">
      开始考核，请拨打电话（<font color="red">{{ callPhone }}</font>）完成考核。
    </div>
    <div class="tips" v-if="isCurrent == 'No'">
      请耐心等待考核，预估考核时间：{{ expectExamineTime }}，考核电话：<font color="red">{{ callPhone }}</font>
    </div>
    <div class="tips" v-if="isFinish == 'Yes'">
      考核完成，考核结果：<span v-if="passState == 'Passed'">通过</span><span v-if="passState == 'Failed'">未通过</span><span v-if="passState == 'NotExamine'">未考</span><span v-if="passState == 'Loss'">流失</span><span v-if="passState == 'Cancel'">取消资格</span>，得分：{{ score }}分
    </div>
    <h3>当前考核人员</h3>
    <el-table :data="currentlist" border style="width: 100%">
      <el-table-column prop="realName" label="考核人员" width="180" align="center"></el-table-column>
      <el-table-column prop="tjkNumber" label="淘金号" width="180" align="center"></el-table-column>
      <el-table-column label="是否通过" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.passState == 'Passed'">通过</span>
          <span v-if="scope.row.passState == 'Failed'">未通过</span>
          <span v-if="scope.row.passState == 'NotExamine'">未考</span>
          <span v-if="scope.row.passState == 'Loss'">流失</span>
          <span v-if="scope.row.passState == 'Cancel'">取消资格</span>
        </template>
      </el-table-column>
      <el-table-column prop="expectExamineTime" label="预估考核时间" align="center"></el-table-column>
      <el-table-column prop="score" label="综合得分" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column label="是否完成考核" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.isFinish == 'Yes'">是</template>
          <template v-if="scope.row.isFinish == 'No'">否</template>
        </template>
      </el-table-column>
    </el-table>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <h3>考核名单</h3>
      <p class="tj-shift-notice" v-if="!list.length">暂无记录！</p>
      <template v-else>
        <el-table :data="list" border style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column prop="sequence" label="顺序" width="60" align="center"></el-table-column>
          <el-table-column prop="realName" label="考核人员" width="180" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" width="180" align="center"></el-table-column>
          <el-table-column prop="expectExamineTime" label="预估考核时间" align="center"></el-table-column>
          <el-table-column label="是否完成考核" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.isFinish == 'Yes'">是</template>
              <template v-if="scope.row.isFinish == 'No'">否</template>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      success: true,
      message: '',
      groupId: this.$route.query.groupId,
      interval: null, //轮询状态
      callPhone: '', //外呼电话号码
      tjkExamRecord: null, //当前考核人员
      list: [], //待考核名单列表
      isCurrent: '', //是否进行考核
      passState: '', //是否通过
      score: '', //得分
      expectExamineTime: '', //预估考核时间
      isFinish: '', //是否完成考核
      currentlist: []
    }
  },
  mounted: function() {
    this.intervalFun()
    this.getList()
  },
  methods: {
    //轮询代码
    intervalFun() {
      let self = this
      self.interval = setInterval(() => {
        console.log('this is interval...')
        self.getList()
      }, 30000)
    },
    //查询考核名单列表
    getList() {
      var data = {
        'groupId': this.groupId
      }
      this.$http.post(API_ROOT.college + '/operatorExam/getTjkOperatorExamView', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if(result.success) {
          this.list = result.data.operatorExamRecords
          this.tjkExamRecord = result.data.tjkExamRecord
          if(this.tjkExamRecord) {
            this.passState = result.data.tjkExamRecord.passState
            this.score = result.data.tjkExamRecord.score
            this.isCurrent = result.data.tjkExamRecord.isCurrent
            this.expectExamineTime = result.data.tjkExamRecord.expectExamineTime
            let arr = []
            arr.splice(0, 1, result.data.tjkExamRecord)
            this.currentlist = arr
          }else {
            this.passState = ''
            this.score = ''
            this.isCurrent = ''
            this.expectExamineTime = ''
            this.currentlist = []
          }
          this.callPhone = result.data.callPhone
          for(var i=0;i<result.data.operatorExamRecords.length;i++) {
            if(result.data.operatorExamRecords[i].isCurrent == 'Yes') {
              this.isFinish = result.data.operatorExamRecords[i].isFinish
            }
          }
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //当前淘金客高亮
    tableRowClassName({row, rowIndex}) {
      if (row.isCurrent == 'Yes') {
        return 'myself-row'
      }
      return ''
    }
  }
}
</script>
<style type="less" scoped>
  .tips {
    background-color: #3b3b62;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 20px;
  }
  .tips p {
    padding: 5px 0;
  }
  h3 {
    margin-top: 20px;
  }
</style>


// WEBPACK FOOTER //
// ./src/page/provider/tjkExamOperator.vue